import KidoAPIInstance from "../../services/KidoConfigApi";

export const getInfomationStoreDetailApi = async () => {
	const path = "api/getDetail";
	return await KidoAPIInstance.get(path);
};

export const postUploadImageProfileApi = async files => {
	const formData = new FormData();
	formData.append("file", files);
	const path = "api/getDetail";
	return await KidoAPIInstance.post(path, formData);
};

export const postUpdateInfomationStoreApi = async dataUpdate => {
	const path = "api/update";
	return await KidoAPIInstance.post(path, dataUpdate);
};
